"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useChainbridge = exports.ChainbridgeProvider = void 0;
var ChainbridgeContext_1 = require("./ChainbridgeContext");
Object.defineProperty(exports, "ChainbridgeProvider", { enumerable: true, get: function () { return ChainbridgeContext_1.ChainbridgeProvider; } });
Object.defineProperty(exports, "useChainbridge", { enumerable: true, get: function () { return ChainbridgeContext_1.useChainbridge; } });
//# sourceMappingURL=index.js.map